import App from '@/configs/app.js'
import Google from '@/configs/Google.js'
import Bitly from '@/configs/Bitly.js'
import Facebook from '@/configs/Facebook.js'
import Smartlook from '@/configs/Smartlook.js'

export default {
  ...App,
  Google,
  Bitly,
  Facebook,
  Smartlook,
}
